import React from "react";
import TabbedPage from "../../../../shared/ui/TabbedPage";
import TargetsTab from "../../../targets/components/TargetsTab";

export default function UsersPage() {
  return (
    <TabbedPage
      title="تنظیمات پرسنل"
      defaultTab="targets"
      tabs={[
        {
          id: "targets",
          label: "تارگت‌ها",
          component: TargetsTab,
        },
      ]}
    />
  );
}
